import { adminRecords } from "./adminRecords";
import React, { useEffect, useState } from "react";
import Utils from "./../Utils";
import Card from "../models/Card";
import DataTable from "react-data-table-component";

import { Link } from "react-router-dom";
import update from "react-addons-update";
import classnames from "classnames";
var dateFormat = require("dateformat");

function Likes(props) {
  //const [favs, setFavs] = useState([]);
  const [results, setResults] = useState([]);
  const [events, setEvents] = useState([]);
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setPage] = useState(1);

  async function query(page, clear = false) {
    const ref = adminRecords.collection("events").where("eventType", "in", ["like", "dislike"]);
    let source = null;
    let query;
    let set = {};

    if (queries[page] && !clear) {
      query = queries[page];
    } else {
      query = ref.limit(25).orderBy("createdAt", "desc");

      if (source) {
        query = query.where("source", "==", source.value);
      }

      if (page != 1) {
        // look at previous page to build next query
        let result = results[page - 1];

        if (result) {
          query = query.startAfter(result[result.length - 1]);
        } else {
          console.log("Cannot construct a query for a page that is not adjacent to one already fetched");
        }
      }

      setQueries(update(queries, { [page]: { $set: query } }));
    }

    if (props.user) {
      query = query.where("userId", "==", props.user.uid);
    }

    let querySnapshot = await query.get();

    set.completions = querySnapshot.docs;

    await props.userCache.fetchIds(
      querySnapshot.docs.map((doc) => {
        return doc.get("userId");
      })
    );

    setEvents(querySnapshot.docs);
    setResults(update(results, { [page]: { $set: querySnapshot.docs } }));
    setLoading(false);
  }

  useEffect(() => {
    query(currentPage);
  }, [currentPage]);

  // useEffect(() => {
  //   setQueries([]);
  //   query(currentPage, true);
  // }, [source]);

  const columns = [
    {
      name: "Date",
      selector: (row) => {
        return dateFormat(row.get("createdAt").toDate(), "mm/dd/yyyy hh:mm:ss");
      },
      sortable: false,
    },
    {
      name: "Type",
      selector: (row) => {
        return row.get("eventType");
      },
      sortable: false,
    },
    {
      name: "User",
      selector: (row) => {
        let user = props.userCache.getUser(row.get("userId"));
        if (user) {
          return <Link to={"/admin/user/" + user.email}>{user.displayName || user.email}</Link>;
        } else {
          return "User Deleted";
        }
      },
      sortable: false,
    },
    {
      name: "Source",
      selector: (row) => {
        let card = row.get("card");
        return Card.name(card.source);
      },
      sortable: false,
    },
    {
      name: "Prompt",
      selector: (row) => {
        let card = row.get("card");
        return card[Card.summaryKey(card.source)].slice(0, 50) + "...";
      },
      sortable: false,
    },
  ];

  const ExpandableComponent = ({ data }) => {
    let card = data.get("card");
    let path = data.get("path");

    let content = card.content;
    let out = [];

    console.log(content);

    let i = 0;

    for (const [key, value] of Object.entries(content)) {
      if (typeof value === "string") {
        let highlight = path[1] === i;

        out.push(
          <div className={classnames({ card: true, highlight: highlight })}>
            <h4>{i + 1}</h4>
            <div>{Utils.nl2br(value)}</div>
          </div>
        );
      } else {
        let highlight = path[0] === key;

        // it's an object with headings
        out.push(
          <div className={classnames({ card: true, highlight: highlight })}>
            <h4>{key}</h4>
            <div>{Utils.nl2br(value.join("\n\n"))}</div>
          </div>
        );
      }

      i += 1;
    }

    let passage;

    if (card.passage) {
      passage = (
        <>
          <h3>Passage</h3>
          <div className="card">{Utils.nl2br(card.passage)}</div>
        </>
      );
    }

    return (
      <div className="expanded-row">
        <div className="inner">
          <h3>Prompt</h3>
          <div className="card">{Utils.nl2br(card[Card.summaryKey(card.source)])}</div>

          {passage}

          <h3>Content</h3>
          {out}
        </div>
      </div>
    );
  };

  return (
    <>
      {/* <Select
        className={"select"}
        value={source}
        onChange={selectedOption => {
          setSource(selectedOption);
        }}
        options={FILTER_SOURCES}
      />             */}
      <DataTable
        columns={columns}
        responsive={true}
        progressPending={loading}
        expandableRows
        expandableRowsComponent={<ExpandableComponent />}
        pagination
        paginationServer
        paginationPerPage={25}
        paginationRowsPerPageOptions={[25]}
        paginationTotalRows={99999999}
        onChangePage={(page) => {
          setPage(page);
        }}
        data={events}
      />
    </>
  );
}

export default Likes;
